import React, { useState } from "react";
import PortalModal from "../../Portals";
import {
  ContentModal,
  ContentModalActiveSurvey,
  Label1,
  Label2,
  Button,
} from "./IceModal.styled";
import IceModalImage from "../../assets/IceButton.png";

const IceButtonComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      {isModalOpen && (
        <PortalModal>
          <ContentModal>
            <ContentModalActiveSurvey>
              <img src={IceModalImage} className="img" alt="ice-modalimage" />
              <Label1>We are looking to help you</Label1>
              <Label2>In minutes a coach will contact you.</Label2>
              <Button onClick={handleCloseModal}>
                <span className="button">Close</span>
              </Button>
            </ContentModalActiveSurvey>
          </ContentModal>
        </PortalModal>
      )}
    </>
  );
};

export default IceButtonComponent;
